import { render } from "./QuantityInput.vue?vue&type=template&id=fd2e167a&scoped=true&lang=true"
import script from "./QuantityInput.vue?vue&type=script&lang=js"
export * from "./QuantityInput.vue?vue&type=script&lang=js"

import "./QuantityInput.vue?vue&type=style&index=0&id=fd2e167a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2e167a"]])

export default __exports__